import { isPlatformBrowser } from '@angular/common';
import { Component, Injector, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, RouterOutlet, NavigationStart } from '@angular/router';
import { ConfirmationModalComponent } from '@app/core/shared/components';
import { COMMON_MODULES } from '@app/core/constants/common-module.constant';
import { FooterComponent } from '../footer/footer.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { filter } from 'rxjs';
import { LocalStorageService, SharedDataService } from '@src/app/core/services';
import { PROFILE } from '@src/app/core/constants';
import { NgxUiLoaderModule } from "ngx-ui-loader";
@Component({
  selector: 'app-layout-base',
  standalone: true,
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  imports: [
    ...COMMON_MODULES,
    RouterOutlet,
    SidebarComponent,
    NavbarComponent,
    ConfirmationModalComponent,
    FooterComponent,
    NgxUiLoaderModule
  ],
})
export class BaseComponent implements OnInit {
  isLoading: boolean | any;
  public isBrowser: boolean = false;
  private readonly platformId: any;
  private route = inject(Router)
  private localStorageService = inject(LocalStorageService)
  public sharedDataService = inject(SharedDataService);
  public No_Footer_Routes = ['profile', 'payment'];
  constructor(
    injector: Injector,
    private router: Router,
  ) {
    this.platformId = injector.get(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(this.platformId);
    // console.log('platform ID: ', this.platformId);
    // console.log('browser: ', this.isBrowser);
    // Spinner for lazyload modules
    router.events.forEach(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }
  ngOnInit(): void {
    this.route.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(
      (event: any) => {
        this.footerCheck(event.url);
        console.log('checking');

      }
    )
    this.footerCheck()
  }
  footerCheck(url?: any) {
    const urlPath = url ? url : this.route.url
    if (this.localStorageService.getDataInLocalStorage("token") && (urlPath.includes(PROFILE) || urlPath.includes('payment'))) {
      this.sharedDataService.user.update(() => true)
    }
    else {
      this.sharedDataService.user.update(() => false)
    }
  }
}
